import React, { useState, useRef, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import CachedIcon from '@material-ui/icons/Cached';
import Box from '@material-ui/core/Box';
import { QuickAppointmentContext } from '../../Context';
import SearchResult from './SearchResult';
import { apiGet } from '../../brainApi';
import useStyles from '../styles';
import { disableAutofill } from '../../helper';

let search_query = null;

const Search = () => {
  const ref = useRef(null);
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const { toggleSearch, setToggleSearch } = useContext(QuickAppointmentContext);
  const classes = useStyles();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setToggleSearch(false);
    }
  };

  useEffect(() => {
    // Bind the event listener
    // eslint-disable-next-line no-undef
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      // eslint-disable-next-line no-undef
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  useEffect(() => {
    let timeout = null;
    const getSearchData = (searchString) => {
      if (searchString.length > 2) {
        setLoading(true);
        const filter = { q: searchString };
        const params = { filter: JSON.stringify(filter) };
        apiGet('/customer-search-detail', params).then((data) => {
          setResults(data);
          setLoading(false);
          setToggleSearch(true);
        });
      }
    };
    if (inputRef.current) {
      // Listen for keystroke events
      inputRef.current.addEventListener('keyup', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          getSearchData(inputRef.current.value);
          search_query = inputRef.current.value;
        }, 1000);
      });
    }
  }, [inputRef]);

  return (
    <Box
      className={classes.searchWrapper}
      display="flex"
      alignItems="center"
      ref={ref}
    >
      {loading ? (
        <CachedIcon className={classes.fieldIcon} />
      ) : (
        <SearchIcon className={classes.fieldIcon} />
      )}
      <TextField
        fullWidth
        placeholder="Select or create a customer"
        inputRef={inputRef}
        autoComplete={disableAutofill}
      />
      {results && toggleSearch && (
        <SearchResult
          results={results}
          search_query={search_query}
          allowCreate
        />
      )}
    </Box>
  );
};

export default Search;
